export default "data:image/gif;base64,R0lGODdhEgAMAPEAAP8ZJP///wAmgAAAACwAAAAAEgAMAEACI5QfqcB9qFJzT0Q5QbU363oF3haOYJeR6KRG5lOmpyvDa1MAADs="